var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-menu',{directives:[{name:"easyadmin",rawName:"v-easyadmin",value:(_vm.easyadminId),expression:"easyadminId"}],class:_vm.contentType,attrs:{"content":_vm.content,"id":`ref-${_vm.easyadminId}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }